import React from "react";
import {Navigate} from "react-router";

const Redirect = ({to}) => {
    return <Navigate to={to} replace />
}

export default Redirect;